<template>
<div>
    <v-container grid-list-md fluid>
        <v-layout row wrap fill-height>
            <v-card outlined class="pa-2" style="min-height: 418px; min-width: 100%;">
                <v-sheet class="d-flex pa-2 light-bg">
                    <p class="text-color">Today's Pending Registrations</p>
                    <v-spacer></v-spacer>
                    <div class="ml-5 count-bg-color"><p class="float_left pr-2 pl-2 letter-spacing-2">{{ count |TwoDigitNumber }}</p></div>
                </v-sheet>
                  
                <div class="mt-3">
                    <v-data-table :headers="headers" 
                    :items="registration" 
                   :footer-props="{'items-per-page-options': [5]}"  
                    :items-per-page="5"
                    :loading="is_loading"
                    class="elevation-0">
                        <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                            <tbody>
                                <tr v-for="item in items" :key="item.name">
                                    <td>
                                        <router-link :to="{ name:'showRegistrationDetails',params: { id:item.id } }">
                                            {{ item.record.name |capitalize}}
                                        </router-link>
                                    </td>
                                    <!-- <td>{{ item.purpose |capitalize}}</td> -->
                                    <td>
                                        <router-link :to="{ name:'showRegistrationDetails',params: { id:item.id } }">View Detail</router-link>
                                    </td>
                                     <td v-if="registration_details.status != 'approved'">
                                         <v-btn small text color="warning" @click="updateRegistrationStatus('approved',item.id)">Approve</v-btn>
                                     </td>
                                      <td v-if="registration_details.status != 'approved'">
                                         <v-btn small text color="error" @click="updateRegistrationStatus('rejected',item.id)">Reject</v-btn>
                                     </td>
                                     
                                </tr>
                            </tbody>
                        </template>
                        <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    methods: {
        getTodaysVisits: function () {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/dashboard/todayspendingregistration`).then((response) => {
                if (response.data.status == 1) {
                    this.registration = response.data.registration;
                    this.count = response.data.count;
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
          updateRegistrationStatus(status, id) {
            this.registration_details.status = status;
            this.registration_details.id = id;
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/registrations/updatestatus`, this.registration_details).then((response) => {
                    if (response.data.status == 1) {  console.log(response);
                        this.$router.push({
                            name: 'showRegistrationDetails',
                            params: {
                                id: response.data.registration_details.id,
                                success_message:response.data.message,
                            }
                        });

                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
    },
    computed: {

    },
    data: () => {
        return {
            count: '',
            registration: [],
            is_loading: false,
            total_items: 10,
            options: {},
            headers: [{
                    text: 'Visitor',
                    value: 'record.name',
                    sortable: true
                },
               
                {
                    text: 'Action',
                    value: 'action'
                },
                 {
                    text: 'Approve',
                    value: 'approve',
                    sortable: false
                },
                 {
                    text: 'Reject',
                    value: 'type',
                    sortable: false
                },

            ],

            registration_details: {
                id: '',
                status: ''
            },
        }
    },
    mounted() {
        this.getTodaysVisits();
    }
};
</script>
